// automatically generated by the FlatBuffers compiler, do not modify
import * as flatbuffers from 'flatbuffers';
import { Column } from "../flat-geobuf/column.js";
import { Crs } from "../flat-geobuf/crs.js";
import { GeometryType } from "../flat-geobuf/geometry-type.js";
export class Header {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsHeader(bb, obj) {
        return (obj || new Header()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsHeader(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Header()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    name(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    envelope(index) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
    }
    envelopeLength() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    envelopeArray() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset
            ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset))
            : null;
    }
    geometryType() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : GeometryType.Unknown;
    }
    hasZ() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? Boolean(this.bb.readInt8(this.bb_pos + offset)) : false;
    }
    hasM() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? Boolean(this.bb.readInt8(this.bb_pos + offset)) : false;
    }
    hasT() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? Boolean(this.bb.readInt8(this.bb_pos + offset)) : false;
    }
    hasTm() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? Boolean(this.bb.readInt8(this.bb_pos + offset)) : false;
    }
    columns(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset
            ? (obj || new Column()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb)
            : null;
    }
    columnsLength() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    featuresCount() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? this.bb.readUint64(this.bb_pos + offset) : BigInt('0');
    }
    indexNodeSize() {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 16;
    }
    crs(obj) {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset
            ? (obj || new Crs()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb)
            : null;
    }
    title(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 26);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    description(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 28);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    metadata(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 30);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startHeader(builder) {
        builder.startObject(14);
    }
    static addName(builder, nameOffset) {
        builder.addFieldOffset(0, nameOffset, 0);
    }
    static addEnvelope(builder, envelopeOffset) {
        builder.addFieldOffset(1, envelopeOffset, 0);
    }
    static createEnvelopeVector(builder, data) {
        builder.startVector(8, data.length, 8);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addFloat64(data[i]);
        }
        return builder.endVector();
    }
    static startEnvelopeVector(builder, numElems) {
        builder.startVector(8, numElems, 8);
    }
    static addGeometryType(builder, geometryType) {
        builder.addFieldInt8(2, geometryType, GeometryType.Unknown);
    }
    static addHasZ(builder, hasZ) {
        builder.addFieldInt8(3, Number(hasZ), Number(false));
    }
    static addHasM(builder, hasM) {
        builder.addFieldInt8(4, Number(hasM), Number(false));
    }
    static addHasT(builder, hasT) {
        builder.addFieldInt8(5, Number(hasT), Number(false));
    }
    static addHasTm(builder, hasTm) {
        builder.addFieldInt8(6, Number(hasTm), Number(false));
    }
    static addColumns(builder, columnsOffset) {
        builder.addFieldOffset(7, columnsOffset, 0);
    }
    static createColumnsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startColumnsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addFeaturesCount(builder, featuresCount) {
        builder.addFieldInt64(8, featuresCount, BigInt('0'));
    }
    static addIndexNodeSize(builder, indexNodeSize) {
        builder.addFieldInt16(9, indexNodeSize, 16);
    }
    static addCrs(builder, crsOffset) {
        builder.addFieldOffset(10, crsOffset, 0);
    }
    static addTitle(builder, titleOffset) {
        builder.addFieldOffset(11, titleOffset, 0);
    }
    static addDescription(builder, descriptionOffset) {
        builder.addFieldOffset(12, descriptionOffset, 0);
    }
    static addMetadata(builder, metadataOffset) {
        builder.addFieldOffset(13, metadataOffset, 0);
    }
    static endHeader(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static finishHeaderBuffer(builder, offset) {
        builder.finish(offset);
    }
    static finishSizePrefixedHeaderBuffer(builder, offset) {
        builder.finish(offset, undefined, true);
    }
}
